import {Button, Form, Image, Input, Select, Spin, Typography} from "antd";
import {Callbacks} from "rc-field-form/lib/interface";
import React, {useEffect, useState} from "react";
import Api from "../common/Api";
import Logo from "../assets/logo.jpg";
import ReCAPTCHA from "react-google-recaptcha";
import variables from "../common/variables";

interface Props {
    spinning: boolean;
    onFinish: Callbacks['onFinish'];
    onFinishFailed: Callbacks['onFinishFailed'];
    group: string;
}

interface SelectOptions {
    label: string;
    value: string
}

const {Title} = Typography;

const fetchData = async () => {
    return await Api.management.getManufacturers();
}

const SignUpForm = ({spinning, onFinish, group, onFinishFailed}: Props) => {
    const [manufacturers, setManufacturers] = useState<SelectOptions[]>();
    const [loading, setLoading] = useState(true);
    const [form] = Form.useForm();

    useEffect(() => {
        (async () => {
            form.setFieldsValue({
                manufacturer: group
            })
            /* setLoading(true)
            const manufacturersData = await fetchData();
            setManufacturers(manufacturersData.data);
            setLoading(false) */
        })()
    }, [form, group])

    return (
        <Spin tip="Loading..." spinning={spinning}>
            <Form
                form={form}
                style={{height: "100%"}}
                name="basic"
                labelAlign={"left"}
                wrapperCol={{
                    sm: {span: 15, offset: 4},
                    md: {span: 10, offset: 7},
                    lg: {span: 8, offset: 8},
                    xl: {span: 6, offset: 9},
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item>
                    <Title level={4} type="secondary" style={{textAlign: "center"}}>ACT Tracker Sign-up page</Title>
                    <Image
                        preview={false}
                        width={"100%"}
                        src={Logo}
                    />
                </Form.Item>
                <Form.Item className='form'>
                    <Form.Item
                        name="firstName"
                        className='first-name'
                        hasFeedback
                        rules={[{required: true, message: 'Please input your first name!'}]}
                    >
                        <Input placeholder="First Name"/>
                    </Form.Item>
                    <Form.Item
                        className='last-name'
                        name="lastName"
                        hasFeedback
                        rules={[{required: true, message: 'Please input your last name!'}]}
                    >
                        <Input placeholder="Last Name"/>
                    </Form.Item>
                </Form.Item>

                <Form.Item
                    name="email"
                    hasFeedback
                    rules={[{required: true, type: "email", message: 'Invalid email address!',}]}
                >
                    <Input placeholder="Email"/>
                </Form.Item>

                <Form.Item name='manufacturer' rules={[{required: true, message: 'Select a manufacturer!'}]}>
                    <Select showSearch
                            disabled
                            loading={loading}
                            options={[{value: group, label: group}]}
                            placeholder={"Group"} />
                           {/*  notFoundContent={manufacturers ? <Spin size="small"/> : null}
                            filterOption={(input, option) => (option!.label as unknown as string).includes(input)}
                            filterSort={(optionA, optionB) =>
                                (optionA!.label as unknown as string)
                                    .toLowerCase()
                                    .localeCompare((optionB!.value as unknown as string).toLowerCase())
                            }/> */}
                </Form.Item>

                <Form.Item
                    name="password"
                    rules={[{required: true, message: 'Please input your password!'}]}
                    hasFeedback
                >
                    <Input.Password placeholder="Password"/>
                </Form.Item>

                <Form.Item
                    name="confirmPassword"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password!',
                        },
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('The two passwords that you entered do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder="Confirm Password"/>
                </Form.Item>


                <Form.Item name="captcha" hasFeedback rules={[{required: true, message: 'Complete captcha!'}]}>
                    <ReCAPTCHA
                        onChange={(ev) => form.setFieldsValue({captcha: ev})}
                        sitekey={variables.captchaKey!}
                    />
                </Form.Item>

                <Form.Item wrapperCol={{
                    sm: {span: 15, offset: 4},
                    md: {span: 10, offset: 7},
                    lg: {span: 8, offset: 8},
                    xl: {span: 6, offset: 9},
                }}>
                    <Button style={{width: "100%"}} type="primary" htmlType="submit">
                        Sign Up
                    </Button>
                </Form.Item>
            </Form>
        </Spin>

    )
}

export default SignUpForm;
